import React from 'react'
import HmsSection1 from './HmsSection1'
import HMSKeyFeatures from './HMSKeyFeatures'
import HmsChoose from './HmsChoose'
import HMSFAQ from './HMSFAQ'
import HmsBussinessTransforn from './HmsBussinessTransforn'

const HmsProduct = () => {
  return (
    <div>
        <HmsSection1/>
        <HMSKeyFeatures/>
        <HmsChoose/>
        <HMSFAQ/>
        <HmsBussinessTransforn/>
    </div>
  )
}

export default HmsProduct